import type { FC } from 'react';
import React, { Fragment } from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import SegmentTitleMapItinerary from './SegmentTitleMapItinerary';
import type { CompletedSegment } from '@/components/FlightSummary/Segment/resolver';
import SectionMapItinerary from './SectionMapItinerary';
import StopOverMapItinerary from './StopOverMapItinerary';

interface SegmentMapItineraryProps {
  segment: CompletedSegment;
  indx: number;
  isMultiDestination: boolean;
}

const SegmentMapItinerary: FC<SegmentMapItineraryProps> = ({
  segment,
  indx,
  isMultiDestination,
}) => {
  const { t } = useTranslation();
  const segmentName = isMultiDestination
    ? t('flightSummary.itinerary.segment.name.multiple', {
        multipleText: t(
          `flightSummary.itinerary.segment.name.multiples${indx}`
        ),
      })
    : indx === 0
      ? t('flightSummary.itinerary.segment.departure')
      : t('flightSummary.itinerary.segment.return');
  const duration = segment.duration;
  const sections = segment.sections;
  const isTrain = segment?.transportTypes[0] === 'TRAIN';

  return (
    <>
      <SegmentTitleMapItinerary
        title={segmentName}
        duration={duration as number}
        indx={indx}
      />
      {sections.map((section, idx) => (
        <Fragment key={`${section.id}_${idx}`}>
          <SectionMapItinerary section={section} isTrain={isTrain} />
          {idx + 1 !== segment.sections.length && segment.stops[idx] && (
            <StopOverMapItinerary {...segment.stops[idx]} />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default SegmentMapItinerary;
